const TimeSaveIcon = (props: any) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 128 128"
            {...props}
        >
            <circle
                cx="64"
                cy="64"
                r="64"
                fill="#18AB7F"
                fillOpacity=".7"
                opacity=".3"
            />
            <path
                fill="#FCFCFC"
                d="M64.47 101.633c22.434 0 40.622-17.651 40.622-39.423 0-21.772-18.188-39.422-40.623-39.422-22.44 0-40.628 17.65-40.628 39.422s18.187 39.423 40.628 39.423Z"
            />
            <path
                fill="#8FA3B5"
                fillRule="evenodd"
                d="M24.91 61.301h8.803v1.82h-8.804a37.372 37.372 0 0 0 4.834 17.508l3.75-2.103.942 1.576-3.751 2.101c3.28 5.213 7.811 9.606 13.18 12.791l2.165-3.585 1.618.92-2.16 3.577c5.376 2.857 11.511 4.539 18.04 4.685v-8.54h1.876v8.54c6.528-.146 12.664-1.828 18.039-4.685l-2.16-3.578 1.618-.92 2.166 3.586c5.381-3.19 9.912-7.593 13.199-12.817l-3.706-2.075.941-1.576 3.7 2.076a37.337 37.337 0 0 0 4.82-17.482h-8.803v-1.819h8.803a37.337 37.337 0 0 0-4.82-17.482l-3.7 2.077-.94-1.576 3.705-2.076c-3.287-5.224-7.818-9.626-13.2-12.817L82.9 33.013l-1.617-.92 2.159-3.577c-5.375-2.858-11.51-4.538-18.04-4.686v8.54h-1.875v-8.54c-6.529.148-12.664 1.828-18.04 4.685l2.16 3.578-1.618.92-2.165-3.586c-5.369 3.185-9.9 7.579-13.18 12.791l3.75 2.102-.94 1.576-3.751-2.103a37.367 37.367 0 0 0-4.834 17.508Zm-1.883.91C23.027 40.003 41.582 22 64.468 22c22.886 0 41.434 18.003 41.434 40.211 0 22.207-18.548 40.21-41.434 40.21s-41.44-18.003-41.44-40.21Z"
                clipRule="evenodd"
            />
            <path
                fill="#18AB7F"
                d="M55.241 60.326a2.794 2.794 0 0 0-1.86-.665 2.786 2.786 0 0 0-1.837.72 2.543 2.543 0 0 0-.832 1.721c-.04.653.18 1.297.616 1.801l8.766 8.648c.253.253.556.454.892.593.337.138.699.21 1.065.21.364.003.724-.065 1.06-.199.337-.133.641-.33.896-.578L82.43 54.43c.25-.245.446-.535.579-.853a2.496 2.496 0 0 0-.03-1.992 2.6 2.6 0 0 0-.603-.837 2.747 2.747 0 0 0-.894-.552 2.845 2.845 0 0 0-2.088.028c-.33.135-.627.331-.877.576l-16.44 16.23-6.836-6.704Z"
            />
            <path
                fill="#18AB7F"
                d="M64.548 17.736a45.132 45.132 0 1 1-37.704 20.326l4.5 2.96a39.747 39.747 0 1 0 33.204-17.9v-5.386Z"
            />
            <path
                fill="#18AB7F"
                d="m31.76 33.935 1.8 5.332-15.996 5.396-1.799-5.332z"
            />
            <path
                fill="#18AB7F"
                d="m26.6 35.733 5.33-1.799 5.397 15.996-5.332 1.798z"
            />
        </svg>
    );
};

export default TimeSaveIcon;
